import { NgModule } from '@angular/core';
import { InputComponent } from './component/input/input.component';
import { LabelComponent } from './component/label/label.component';
import { CommonModule } from '@angular/common';
import { NumericDirective } from './directive/numeric.directive';
import { NumericDecimalDirective } from './directive/numeric-decimal.directive';
import {
  SelectFooterTemplateDirective, SelectHeaderTemplateDirective,
  SelectItemLabelDirective,
  SelectLabelTemplateDirective, SelectLoadingSpinnerTemplateDirective, SelectLoadingTextTemplateDirective,
  SelectMultiLabelTemplateDirective, SelectNotFoundTemplateDirective,
  SelectOptgroupTemplateDirective,
  SelectOptionTemplateDirective, SelectTagTemplateDirective, SelectTypeToSearchTemplateDirective
} from './directive/select-templates.directive';
import { InputTrimDirective } from './directive/input-trim.directive';
import { CutDirective } from './directive/cut.directive';
import { PhoneMaskDirective } from './directive/phone-mask.directive';
import { ControlErrorsComponent } from './component/control-errors/control-errors.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TooltipComponent } from './component/tooltip/tooltip.component';

/**
 * Изменение названия кнопок для плагина ng-pick-datetime
 */
@NgModule({
    declarations: [
        InputComponent,
        TooltipComponent,
        InputTrimDirective,
        LabelComponent,
        NumericDirective,
        NumericDecimalDirective,
        CutDirective,
        PhoneMaskDirective,
        SelectItemLabelDirective,
        SelectOptionTemplateDirective,
        SelectOptgroupTemplateDirective,
        SelectLabelTemplateDirective,
        SelectMultiLabelTemplateDirective,
        SelectHeaderTemplateDirective,
        SelectFooterTemplateDirective,
        SelectNotFoundTemplateDirective,
        SelectTypeToSearchTemplateDirective,
        SelectLoadingTextTemplateDirective,
        SelectTagTemplateDirective,
        SelectLoadingSpinnerTemplateDirective,
        ControlErrorsComponent,
    ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ],
    exports: [
        InputComponent,
    ],
  providers: [
  ],
})
export class FormElementRenderModule {}
